import CircleDashed from 'components/shared/Icon/icons/CircleDashed';
import CircleLight from 'components/shared/Icon/icons/CircleLight';
import CircleRegular from 'components/shared/Icon/icons/CircleRegular';
import CircleSolid from 'components/shared/Icon/icons/CircleSolid';
import CircleSolidHalfStroke from 'components/shared/Icon/icons/CircleSolidHalfStroke';
import { SafariPortalIconStyles } from 'constants/fontAwesome';

export const ICON_FILTER_RADIO_BUTTONS = [
  { type: SafariPortalIconStyles.SOLID, label: 'Solid', circleIcon: CircleSolid },
  { type: SafariPortalIconStyles.REGULAR, label: 'Regular', circleIcon: CircleSolidHalfStroke },
  { type: SafariPortalIconStyles.LIGHT, label: 'Light', circleIcon: CircleRegular },
  { type: SafariPortalIconStyles.THIN, label: 'Thin', circleIcon: CircleLight },
  { type: SafariPortalIconStyles.CUSTOM, label: 'Other', circleIcon: CircleDashed },
];

export const FONT_AWESOME_ICON_STYLES = new Set([
  SafariPortalIconStyles.SOLID,
  SafariPortalIconStyles.REGULAR,
  SafariPortalIconStyles.LIGHT,
  SafariPortalIconStyles.THIN,
]);
